import { AssignRoleToGroupModalComponent } from './AssignRoleToGroupModal.types';
import { Button, Flexbox } from '@hiiretail/synergy-ui';
import { useParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import { Option } from '@hiiretail/synergy-ui/dist/types/components/inputs/Select/Select.types';
import { AssignRoleModal, CancelButton, RoleSelect } from './AssignRoleToGroupModal.styles';
import { CombinedRole } from '../../../GroupDetails.types';

export const AssignRoleToGroupModal: AssignRoleToGroupModalComponent = ({
  groupRoles,
  onClose,
  open,
  roles,
  isAssigning,
  assignRole,
}) => {
  const { id } = useParams<{ id: string }>();
  const [selectedRole, setSelectedRole] = useState<{ value: CombinedRole, label: string } | null>(null);

  const options = useMemo(() => roles
    ?.filter(r => !groupRoles?.find(({ roleId }) => roleId === r.id))
    .map((role: CombinedRole) => ({
      value: role,
      label: role.id,
    })
  ), [roles, groupRoles]);

  const onChange = useCallback((newOption) => {
    setSelectedRole(newOption);
  }, [setSelectedRole]);

  const onSubmit = () => {
    const data = {
      groupId: id,
      roleId: selectedRole?.value.id as string,
      bindings: [],
      isCustom: selectedRole?.value.isCustom as boolean,
    };
    assignRole(data);
  };

  return (
    <AssignRoleModal
      data-testid="assign-role-modal"
      title="Add role"
      onClose={onClose}
      open={open}
      footer={
        <Flexbox container justifyContent="flex-end">
          <CancelButton
            disabled={isAssigning}
            onClick={onClose}
            variant="secondary"
          >
            Cancel
          </CancelButton>
          <Button
            disabled={isAssigning || !selectedRole}
            onClick={onSubmit}
            type="submit"
          >
            Submit
          </Button>
        </Flexbox>
      }
    >
      <RoleSelect
        options={options as unknown as Option[]}
        name="roles"
        label="Select roles to add"
        onChange={onChange}
        fullWidth
      />
    </AssignRoleModal>
  );
}
